// extracted by mini-css-extract-plugin
export default {"checkbox":"CustomCheckbox_checkbox__Srv7X","checkbox-disabled":"CustomCheckbox_checkbox-disabled__012Xy","indeterminate":"CustomCheckbox_indeterminate__NVA0v"};